import { Form, FormItemProps, Input, InputProps } from "antd";

interface IFormItemInputReferralCodeProps extends FormItemProps {
  input?: InputProps;
}

const FormItemInputReferralCode = ({
  input,
  label,
  className,
  ...props
}: IFormItemInputReferralCodeProps) => {
  return (
    <Form.Item
      name="referralCode"
      label={label}
      {...props}
      className={className}
    >
      <Input
        name="referralCode"
        type="text"
        placeholder="추천인 코드를 입력해 주세요."
        {...input}
      />
    </Form.Item>
  );
};

export default FormItemInputReferralCode;
